/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    number, string, bool, shape, arrayOf, func,
} from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';

import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import { FormControlLabel } from '@material-ui/core';
import { form as FormStyle } from '../../../../style/form';
import EventDispatcher from '../../../../state/reducers/EventDispatcher';
import configEnv from '../../../../config';

const { PERSIST_KEY } = configEnv;

const styles = ({ typography, palette }) => FormStyle(typography, palette);

class ConfirmShopTheSite extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dontShowModal: false,
        };
    }

    handleDontShowShopTheSiteClicked = (event) => {
        this.setState({ dontShowModal: event.target.checked });
    };

    render() {
        const { dontShowModal } = this.state;
        const {
            recipient,
            handleConfirmGiftListShopTheSiteClicked,
            handleCloseModal,
        } = this.props;
        const label = "Don't show this information again.";
        return (
            <>
                <p>
                    When you shop the site to find a different gift for your
                    Gift List recipient, you will be taken to our home page
                    where you can browse product offerings.
                </p>
                <FormControlLabel
                    className="no-margin"
                    control={(
                        <Checkbox
                            defaultChecked={false}
                            onChange={(event) => this.handleDontShowShopTheSiteClicked(event)}
                            value="dontShowModal"
                            className=""
                            color="default"
                            inputProps={{
                                'aria-label': 'primary checkbox',
                            }}
                        />
                    )}
                    label={label}
                />

                <div className="align-center margin-top">
                    <Button
                        onClick={() => handleConfirmGiftListShopTheSiteClicked(
                            recipient,
                            '/',
                            dontShowModal,
                        )}
                        variant="contained"
                        color="primary"
                        className="remove-recipient-btn buttonHD margin-bottom-2x"
                    >
                        Shop The Site
                    </Button>
                    <Button
                        onClick={() => handleCloseModal()}
                        variant="contained"
                        className="do-not-remove-btn buttonHDSecondary"
                    >
                        Cancel
                    </Button>
                </div>
            </>
        );
    }
}

ConfirmShopTheSite.propTypes = {
    recipient: shape({
        AddressBookEntryId: string,
        ContactId: number,
        NamePrefix: string,
        FirstName: string,
        MiddleInitial: string,
        LastName: string,
        NameSuffix: string,
        RelationShip: string,
        NickName: string,
        EmailAddress: string,
        LastUpdateDate: string,
        PhoneNumber: string,
        AlternatePhoneNumber: string,
        Fax: string,
        EmployerName: string,
        NumberOfAddresses: number,
        DateOfBirth: string,
        Addresses: arrayOf(
            shape({
                AddressId: number,
                AddressBookEntryId: string,
                AddressType: string,
                AddressLineOne: string,
                AddressLineTwo: string,
                City: string,
                StateProvince: string,
                PostalCode: string,
                Country: string,
                IsPartialMatch: bool,
                IsUnknownAddress: bool,
                Latitude_degrees: number,
                Longitude_degrees: number,
                IsBillingAddress: bool,
                ContactId: number,
            }),
        ),
    }).isRequired,
    handleCloseModal: func.isRequired,
    handleConfirmGiftListShopTheSiteClicked: func.isRequired,
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        recipient: newState.pageData.recipient,
    };
};

const mapDispatchToProps = (dispatch) => ({
    handleConfirmGiftListShopTheSiteClicked: (recipient, url, dontShowModal) => dispatch(EventDispatcher.handleConfirmGiftListShopTheSiteClicked(
        recipient,
        url,
        dontShowModal,
    )),
    handleCloseModal: () => dispatch(EventDispatcher.handleCloseModal()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withStyles(styles)(ConfirmShopTheSite));
